import React from "react";
import { ResultItemListProps } from "models/propTypes/resultItemPropTypes";
import ResultItem from "components/common/lists/resultItem";
import { isUndefined } from "util";
import { Grid } from "@mui/material";

const ResultItemList: React.FC<ResultItemListProps> = (props) => {
  return (
    <Grid container>
      {props.items.map((item, index) => {
        const selectedItem = props.selectedIds.length > 0 ? props.selectedIds.find((x) => x.id === item.id) : undefined;
        const isSelected = !isUndefined(selectedItem);
        const data = selectedItem && selectedItem.data ? selectedItem.data : {};

        return (
          <ResultItem
            key={index}
            {...props}
            item={item}
            getItemTemplate={props.getItemTemplate}
            isSelected={isSelected}
            additionalContentOnSelection={
              props.additionalContentOnSelection ? (
                <props.additionalContentOnSelection.type {...props.additionalContentOnSelection.props} {...data} />
              ) : undefined
            }
          />
        );
      })}
    </Grid>
  );
};

export default ResultItemList;
